import React, { useEffect } from 'react';
import styled from 'styled-components';

export default function ({ COMPANY, CS_EMAIL }: any) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <S.Box>
        <S.SubTitle>개요</S.SubTitle>
        <S.Text>
          채팅 스타일 메모 서비스(이하 "서비스") {COMPANY}에 오신 것을
          환영합니다. 이하는 "미드나잇플랜"(대표 허준혁, CEO Junhyeok Heo)이
          귀하의 {COMPANY}(이하 "사이트") 이용 약관 내용을 담고 있습니다.
          "미드나잇플랜"(이하 "회사" 혹은 "우리")은 대한민국 법에 등록된 회사로
          사업자 번호는 489-03-01218입니다. 이하의 약관을 신중하게 읽고 명확히
          이해 하십시오. 사이트를 이용하시게 되면 사이트 가입 여부와 무관하게 본
          사용 약관(이하 "약관") 을 준수하고 법에 따른다는 것으로 간주합니다. 본
          약관에 동의하지 않으시는 경우, 사이트 관련 정보를 수집하거나 사이트를
          계속 이용하실 수 없습니다. 이하 약관에 위반하여 사이트를 이용하는 경우
          민사 혹은 형사 처벌을 받을 수 있습니다. 회사는 언제든 약관을 변경할
          권리를 가집니다. 귀하가 사이트를 계속해서 이용하는 경우 변경된 약관
          내용에 동의하는 것으로 간주합니다. 따라서, 사용자들은 약관의 변경이
          있는 경우 이를 검토하여야 합니다. 문의가 있는 경우 즉시 {CS_EMAIL}으로
          이메일을 보내주십시오.
        </S.Text>
      </S.Box>
      <S.Box>
        <S.SubTitle>1. 일반 조항</S.SubTitle>
        <S.UList>
          <S.ListItem>
            1.1 본 사이트는 엔터테인먼트 목적으로 제작된 것이며 비도덕적인
            목적을 충족하기 위한 것이 아닙니다.
          </S.ListItem>
          <S.ListItem>
            1.2 귀하는 이로써 당사에 (a) 귀하가 본 약관에 온전하게 동의하고 이에
            의거한 행위를 할 수 있고 (b) 귀하가 본 사이트를 이용하는 것이
            저작권, 트레이드 마크, 초상권 및 기타 제3자의 법적인 권리를 위반하지
            않고 (c) 귀하가 본 사이트 이용과 관련하여 글 게시, 콘텐츠 사용 및
            기타 모든 행위가 법률이나 제3자의 권리를 위반하지 않음을 선언하고
            보장합니다.
          </S.ListItem>
          <S.ListItem>
            1.3 {COMPANY}은 한국에서 개발되고 배포되었습니다. (This app is
            developed and released in Republic of Korea.)
          </S.ListItem>
        </S.UList>
      </S.Box>
      <S.Box>
        <S.SubTitle>
          2. 회원들과 이용자들에 의한 비상업적인 사용 비용
        </S.SubTitle>
        <S.UList>
          <S.ListItem>
            2.1 귀하의 가입 당시 사이트 및 서비스 비용, 내용 및 기간 등에 관한
            내용은 수시로 변경될 수 있으며 전자 통지를 통해 공고합니다. 당사는
            특별한 사유 없이도 귀하의 사이트에 대한 접속을 제지할 수 있으며 가입
            시 등록된 이메일 주소 혹은 기타 이메일 주소로의 통보 후 멤버십을
            종료 시킬 수도 있습니다. 당사가 귀하의 약관 위반을 이유로 멤버십을
            종료시키는 경우, 사용하지 못한 남은 서비스 기간에 대한 환불을
            제공하지 않습니다.
          </S.ListItem>
          <S.ListItem>
            2.2 본 사이트의 결제와 관련하여 법률을 위반하는 경우, 해당 회원 또는
            이용자는 사이트 이용이 즉시 제한되며 본 범법 행위와 관련하여 법률
            당국의 조사 협조가 있는 경우 조사에 필요한 해당 회원 또는 이용자의
            정보를 공유헙나다.
          </S.ListItem>
          <S.ListItem>
            2.3 당사는 당사를 대신하여 사이트 내 결제를 담당하는 제3 기관을
            이용할 수 있습니다. 이러한 제3의 기관은 자체의 개인 정보 보호 정책에
            따라 회원 또는 사용자들의 결제 관련 개인 정보를 보호할 책임이
            있습니다.
          </S.ListItem>
          <S.ListItem>
            2.4 본 사이트는 개별 회원 및 이용자들의 개인적인 용도로 사용되어야
            하며 상업적인 목적으로 사용되어서는 안됩니다. 기관, 회사 및
            사업체들은 본 사이트의 회원으로 가입해서는 안되며 본 사이트 및
            서비스를 이하의 내용 용도로 사용해서는 안됩니다. 회원들에게 상업적인
            이메일 발송, 다른 웹사이트 및 서비스에 대한 광고 또는 회원들의
            개인적인 신원 정보를 상업적인 목적으로 이용, 본 사이트를 불법적이고
            허용되지 않은 목적 이외로 사용하는 경우, 허락되지 않은 프레이밍 및
            사이트 링크 연계, 상업적인 메시지 발송 등이 발생하는 경우 조사를
            진행하게 되며 해당 행위를 처벌하기 위한 민사, 형사 등 관련 법적
            조치를 취함은 물론 당사 스스로의 권한에 따라 멤버십을 종료하는 등의
            행위도 취할 수 있습니다. 원치않는 상업적인 메시지를 이메일 또는
            대화를 통해 전송하지 못하도록 하기 위해 당사는 특정 계정에서 발송 및
            수신된 이메일 및 메시지 수 등을 조사하는 등의 합리적인 조치를 취할
            수 있습니다.
          </S.ListItem>
        </S.UList>
      </S.Box>

      <S.Box>
        <S.SubTitle>3. 프라이버시</S.SubTitle>
        <S.UList>
          <S.ListItem>
            3.1 당사는 사이트에 게시하지는 않지만 귀하의 특정 기타 개인 정보를
            수집할 수 있습니다. 당사는 귀하의 동의 없이는 귀하의 정보를 당사와
            관련이 없는 그 어떤 제3 기관에 제공하지 않습니다. 다만 당사는 당사의
            권리를 보호하거나 지키기 위해, 제3자의 권리를 보호하거나 지키기 위해
            또는 법에 의해, 법원의 명령이나 소환에 응하기 위해서 등 요청되는
            경우 귀하의 특별한 동의 없이도 귀하의 정보를 넘길 수 있습니다. 또한
            당사는 본 사이트 운영을 위해 필요한 범위 내에서 귀하와 다른 사이트
            이용자들에 관한 정보를 제3기관에 제공합니다.
          </S.ListItem>
          <S.ListItem>
            3.2 사진 기타 개인 정보를 사이트에 제공함을 통해 귀하는 당사에게
            지속적이고, 국제적이며, 독점적이지는 않지만 특별한 로열티 없이 해당
            개인 정보를 미디어에서 사용, 재생산, 게시, 수정, 배포 및 홍보할 수
            있도록 허용하는 것으로 간주합니다.
          </S.ListItem>
          <S.ListItem>
            3.3 회원님이 사이트에 접수, 게시, 전송하는 내용들은 전적으로 귀하의
            책임입니다. 이하의 내용들은 사이트에 접수, 게시 또는 전송하실 수
            없습니다.
            <S.UList>
              <S.ListItem>3.3.1 명예훼손.</S.ListItem>
              <S.ListItem>
                3.3.2 어떤 인종, 민족 또는 종교집단을 일반화 시켜 폄하하는 행동
                등.
              </S.ListItem>
              <S.ListItem>
                3.3.3 야한 사진 또는 18세 미만으로 보이는 사진.
              </S.ListItem>
              <S.ListItem>3.3.4 불법 마약 이용 묘사.</S.ListItem>
              <S.ListItem>3.3.5 폭력적인 언어나 이미지 사용.</S.ListItem>
              <S.ListItem>
                3.3.6 폭력을 허용 가능한 것 또는 멋지게 묘사.
              </S.ListItem>
              <S.ListItem>6.3.7 상업적인 사이트로의 링크 제공.</S.ListItem>
              <S.ListItem>
                3.3.8 사이트 가입 시 요청되거나 특별히 요구된 것 이외의 개인
                연락처 정보 게시.
              </S.ListItem>
            </S.UList>
          </S.ListItem>
          <S.ListItem>
            3.4 당사는 귀하 또는 그 어떤 사람의 요구에 따라서도 특정한 글을
            게시할 의무가 없습니다. 또한, 당사는 온전하게 방해받지 않은 스스로의
            결정에 따라, 귀하가 게시하거나 제출한 내용을 수정 또는 삭제할 수
            있습니다.
          </S.ListItem>
          <S.ListItem>
            3.5 본 사이트를 이용함에 있어 본 사이트 내 혹은 제3자 웹사이트
            링크를 통해 귀하는 다른 이용자들이나 제3자가 제공한 내용을 접하게 될
            수 있습니다. 당사는 제3자가 제공한 콘텐츠가 오해의 소지 존재,
            불완전, 잘못된 정보 제공, 공격적이고 불건전하거나 기타 대해 그 어떤
            관리 권한도 가지고 있지 않으며 이에 대한 책임도 지지 않습니다.
          </S.ListItem>
          <S.ListItem>
            3.6 귀하는 가입 시 하나의 아이디와 비밀번호를 설정할 수 있습니다.
            해당 정보들에 대한 보안은 온전히 귀하의 책임입니다. 귀하는 (a)
            사이트 내 각 세션이 종료한 후 로그아웃 및 (b) 귀하의 아이디와
            비밀번호를 이용하여 보안이 의심스러운 상황이 발생한 경우 즉시 당사에
            알려야 할 의무가 있습니다.
          </S.ListItem>
        </S.UList>
      </S.Box>
      <S.Box>
        <S.SubTitle>4. 책임 제한</S.SubTitle>
        <S.UList>
          <S.ListItem>
            4.1 당사는 당사가 특정한 손실에 대해 미리 고지를 받은 경우에도
            이하의 예시와 관련하거나 이로 인한 직간접적, 일반, 특별, 결과로
            인한, 예시적이며 징벌적인 손실 기타 모든 종류의 손해에 대해 책임을
            지지 않습니다. (a) 본 사이트 이용 및 이용할 수 없음 (b) 본 사이트를
            통하거나 사이트에서 얻은 정보 혹은 어떠한 상품, 서비스 및 정보
            구매에 들어간 비용 (c) 권한 없이 귀하가 제공한 정보에의 접근, 수정
            및 공개 (d) 정보 또는 프로그램 오류, 서비스 장애 및 대체 서비스
            구매로 인한 손실 (e) 사이트 내 서비스 제공자 혹은 제3자의 성명, 행위
            및 누락 (f) 사이트 이용과 관련하여 온라인과 오프라인 모든 공간에서
            본 서비스에 가입한 다른 회원들 혹은 사이트에 의해 소개를 받은
            회원들과의 대화 또는 만남에 있어 귀하 혹은 타인의 행위로 인해 발생한
            상해, 심리적 고통, 사망 기타 모든 행위 (g) 본 사이트 이용으로
            인하거나 이와 관련하여 발생하는 것들.
          </S.ListItem>
          <S.ListItem>
            4.2 당사는 본 약관에 따라 당사의 합리적인 주의 여부를 불문하고
            서비스 제공 실패 및 지연에 대한 그 어떠한 책임도 지지 않습니다.
          </S.ListItem>
          <S.ListItem>
            4.3 귀하가 사이트를 이용하는 것은 온전히 스스로의 책임으로
            이루어지는 일입니다. 본 사이트는 "있는 그대로" "사용 가능한" 범위
            내에서 서비스를 제공합니다. 당사는 사이트 이용과 관련하여 명시적이든
            암시된 것이든 이에 국한되지 아니하고 모든 품질 보증서 및 상업 권리
            및 법규에서 보호되는 모든 권리를 귀하에게서 위임받습니다.
          </S.ListItem>
          <S.ListItem>
            4.4 당사는 이하에 대한 보장을 하지 않습니다 (a) 본 사이트가 귀하의
            요구 사항에 적합한 지 여부 (b) 본 사이트의 서비스가 중단되지 않고,
            시기를 잘 맞추며, 안전하고 전혀 에러 존재 하지 않음 (c) 사이트를
            통해 얻게 되는 정보들의 정확성 및 신뢰성 (d) 사이트를 통해 구매 혹은
            획득하게 된 상품, 서비스, 정보 및 기타의 품질이 귀하의 기대에 부응할
            것인지 여부 (e) 귀하가 제공하거나 당사가 수집한 정보가 제3자에 절대
            공개되지 않을 것인지 여부 (f) 모든 정보나 소프트웨어의 에러가 수정될
            것인지 여부.
          </S.ListItem>
          <S.ListItem>
            4.5 귀하가 본 사이트를 이용해 정보에 접근하거나 정보를 전송하는
            경우, 이는 스스로의 재량과 책임하에 진행하는 것입니다. 해당 정보
            접속이나 전송에 의한 그 어떤 손실이나 손해 등은 전적으로 해당 행위를
            한 귀하의 책임입니다.
          </S.ListItem>
          <S.ListItem>
            4.6 당사에서 구두 또는 서면으로 받게 된 문서 정보나 데이터는 본
            약관에 명시되지 않는 한 그 어떤 권리도 발생시키지 않습니다.
          </S.ListItem>
          <S.ListItem>
            4.7 본 항목 및 기타 당사의 책임을 배제시키거나 제한시키는 조항들은
            당사는 물론이고 당사의 임원, 담당자, 직원, 하청업체, 대행업체 및
            파트너들에게 적용됩니다. 본 약관의 그 어떤 부분도 당사의 부주의로
            인해 발생한 사망, 상해 및 사기성이 있는 허위진술 및 기타 법적으로
            배제하거나 제한할 수 없는 부분의 책임까지 배제하거나 제한하지는
            않습니다.
          </S.ListItem>
        </S.UList>
      </S.Box>
      <S.Box>
        <S.SubTitle>4. 소유권</S.SubTitle>
        <S.UList>
          <S.ListItem>
            4.1 사이트 내의 모든 내용들은 홍보권, 저작권, 트레이드마크,
            서비스마크, 특허권, 영업 비밀 기타 다른 상표 권리 및 법의 보호를
            받습니다. 당사에 의해 명시적으로 권한이 부여된 경우를 제외하고
            귀하는 본 사이트에 있는 내용들을 판매, 라이선스, 대여, 수정, 배포,
            복제, 재생산, 전송, 공공 게시, 공공 재연, 출판, 각색, 수정 및
            파생상품 생산을 할 수 없습니다. 다만, 귀하는 사이트 내의 내용을
            일반적이고, 개인적이고, 비상업적인 목적으로는 사용할 수 있습니다.
          </S.ListItem>
          <S.ListItem>
            4.2 시스템을 통해 데이터 혹은 사이트의 다른 정보를 추출하여 축적,
            직간접적으로 일회성 혹은 수차례에 걸쳐 다운로드하거나, 수집, 편집을
            하여서는 안되며 이 방법은 수동 직접이든 "봇츠" 등 기타 프로그램을
            이용한 방법이든 모두 허용되지 않습니다. 다른 웹사이트 혹은 서면
            기타에 당사의 로고 및 모든 트레이드마크를 메타 태그 등으로
            이용해서는 안 됩니다. 당사의 사전 서면 동의 없이는 본 사이트의 일부
            (혹은 링크를 통한 사이트 콘텐츠 연계)를 공개해서는 안 됩니다.
          </S.ListItem>
        </S.UList>
      </S.Box>
      <S.Box>
        <S.SubTitle>5. 개인정보</S.SubTitle>
        <S.UList>
          <S.ListItem>
            4.1 원칙적으로 개인이 원하여 계정 삭제를 신청한 경우에는 지체없이
            해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과
            같습니다.
          </S.ListItem>
          <S.ListItem>
            4.2 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른
            목적으로 이용되지 않습니다.
          </S.ListItem>
          <S.ListItem>
            4.3 {COMPANY}은 정보주체로부터 개인정보를 수집할 때 동의 받은
            개인정보 보유․이용기간 또는 법령에 따른 개인정보 보유․이용기간
            내에서 개인정보를 처리․보유합니다. 전자상거래에서의 계약․청약철회,
            대금결제, 재화 등 공급기록 : 5년
          </S.ListItem>
        </S.UList>
      </S.Box>
    </>
  );
}

const S = {
  Box: styled.div`
    display: flex;
    padding: 25px 0;
    width: 90%;
    max-width: 720px;
    flex-direction: column;
    align-items: flex-start;
  `,
  Title: styled.h1`
    font-size: 32px;
    font-weight: bold;
    margin: 14px 0;
    color: #222;
  `,
  SubTitle: styled.h2`
    font-size: 24px;
    font-weight: 500;
    margin: 10px 0;
    color: #444;
  `,
  Text: styled.p`
    font-size: 18px;
    line-height: 1.8;
    color: #666;
    margin: 5px 0;
  `,
  UList: styled.ul`
    list-style-type: ${(props: any) => (props.type ? props.type : 'disc')};
  `,
  OList: styled.ol`
    list-style-type: decimal;
  `,
  ListItem: styled.li`
    line-height: 1.7;
    margin: 15px 0 15px 20px;
    font-size: 17px;
    color: #777;
  `,
};
